export default __webpack_public_path__ + "static/logo-shopslinker-0d5126bcd4c2c81921bf7c4dfd2a24cd.png";